var map = {
	"./ai_bubble_button-close.png": 480,
	"./ai_bubble_button.png": 481,
	"./ai_search.svg": 482,
	"./arrow_drop_down.svg": 483,
	"./arrow_left.svg": 484,
	"./arrow_right.svg": 485,
	"./article_image.jpg": 486,
	"./article_image_no_image.svg": 487,
	"./author_image.jpg": 488,
	"./award_01.png": 489,
	"./award_02.png": 490,
	"./back_arrow.svg": 491,
	"./banner_image_decor.svg": 492,
	"./bg_stay_on_top.svg": 493,
	"./block_decor_contact_info.svg": 494,
	"./category_blue.svg": 495,
	"./category_cancer_diseases.svg": 496,
	"./category_early_diagnosis.svg": 497,
	"./category_nearest_branch.svg": 498,
	"./category_patient_rights.svg": 499,
	"./category_prevention_risk_factors.svg": 500,
	"./category_rehabilitation_support.svg": 501,
	"./category_рotel_sick.svg": 502,
	"./category_сonsultation_experts.svg": 503,
	"./chevron_black_left.svg": 504,
	"./chevron_blue_down.svg": 505,
	"./chevron_blue_left.svg": 506,
	"./chevron_blue_up.svg": 507,
	"./clock_outside_icon.svg": 508,
	"./close_icon.svg": 509,
	"./decor_contacts.svg": 510,
	"./decor_cr_sub_category.svg": 511,
	"./decor_event_01.svg": 512,
	"./decor_event_02.svg": 513,
	"./decor_event_article.svg": 514,
	"./decor_forum.svg": 515,
	"./decor_top_branch_activities.svg": 516,
	"./default-avatar.webp": 517,
	"./ellipse.png": 518,
	"./error_page_decor.svg": 519,
	"./file_icon.svg": 520,
	"./hero_image.jpg": 521,
	"./hero_image_branches_mobile.jpg": 522,
	"./hero_image_branches_v2.jpg": 523,
	"./hero_image_category.jpg": 524,
	"./hero_image_clinical_researches.jpg": 525,
	"./hero_image_decor.svg": 526,
	"./hero_image_drugs.jpg": 527,
	"./hero_image_events.jpg": 528,
	"./hero_image_events_mobile.jpg": 529,
	"./hero_image_forum.jpg": 530,
	"./hero_image_newsflashes.jpg": 531,
	"./hero_image_newsflashes_mobile.jpg": 532,
	"./hero_image_rights_services.jpg": 533,
	"./hero_image_speaker_messages.jpg": 534,
	"./hero_image_speaker_messages_mobile.jpg": 535,
	"./hero_image_strong_together.jpg": 536,
	"./hero_image_strong_together_mobile.jpg": 537,
	"./icon_Breast_Cancer_Community.svg": 538,
	"./icon_breast_cancer_forum.svg": 539,
	"./icon_cart.svg": 540,
	"./icon_contact_01.svg": 541,
	"./icon_contact_02.svg": 542,
	"./icon_contact_03.svg": 543,
	"./icon_contact_04.svg": 544,
	"./icon_contact_05.svg": 545,
	"./icon_contact_06.svg": 546,
	"./icon_contact_07.svg": 547,
	"./icon_contact_08.svg": 548,
	"./icon_contact_09.svg": 549,
	"./icon_contact_10.svg": 550,
	"./icon_contact_11.svg": 551,
	"./icon_contact_12.svg": 552,
	"./icon_copy.svg": 553,
	"./icon_delete_comment.svg": 554,
	"./icon_editing_comment.svg": 555,
	"./icon_event_schedule.svg": 556,
	"./icon_hand_heal.svg": 557,
	"./icon_info_lamp.svg": 558,
	"./icon_link_blue.svg": 559,
	"./icon_link_green.svg": 560,
	"./icon_link_pink.svg": 561,
	"./icon_link_yellow.svg": 562,
	"./icon_location.svg": 563,
	"./icon_m_contact.svg": 564,
	"./icon_m_lang.svg": 565,
	"./icon_menu_about_association.svg": 566,
	"./icon_menu_cancer_diseases.svg": 567,
	"./icon_menu_early_diagnosis.svg": 568,
	"./icon_menu_information_professionals.svg": 569,
	"./icon_menu_information_support.svg": 570,
	"./icon_menu_prevention_risk_factors.svg": 571,
	"./icon_notice.svg": 572,
	"./icon_pdf.svg": 573,
	"./icon_prevention_diagnosis.svg": 574,
	"./icon_professional_information.svg": 575,
	"./icon_rehabilitation.svg": 576,
	"./icon_report_response.svg": 577,
	"./icon_research.svg": 578,
	"./icon_search.svg": 579,
	"./icon_share_facebook.svg": 580,
	"./icon_share_link.svg": 581,
	"./icon_share_mail.svg": 582,
	"./icon_share_whatsapp.svg": 583,
	"./icon_tel.svg": 584,
	"./icon_volunteering.svg": 585,
	"./icon_volunteers.svg": 586,
	"./img_mini_contact_form.jpg": 587,
	"./location_icon.svg": 588,
	"./logo.svg": 589,
	"./logo_ar.png": 590,
	"./logo_en.png": 591,
	"./logo_he.svg": 592,
	"./logo_purple.svg": 593,
	"./logo_ru.png": 594,
	"./main_g_circle.svg": 595,
	"./manager_icon.svg": 596,
	"./mask_image_slider.svg": 597,
	"./menu_contact.svg": 598,
	"./menu_icon_ltr.svg": 599,
	"./menu_icon_rtl.svg": 600,
	"./menu_language.svg": 601,
	"./menu_volunteering.svg": 602,
	"./no-image.png": 258,
	"./phone_icon.svg": 603,
	"./purple_light.svg": 604,
	"./search_icon_blue.svg": 605,
	"./search_icon_gray.svg": 606,
	"./share_icon.svg": 607,
	"./social_image_facebook.svg": 608,
	"./social_image_instagram.svg": 609,
	"./social_image_tiktok.svg": 610,
	"./social_image_twitter.svg": 611,
	"./social_image_youtube.svg": 612,
	"./step_images_slider.png": 613,
	"./successfully_icon.svg": 614,
	"./tabs_activities_decor.svg": 615,
	"./user.jpg": 616,
	"./user_icon.svg": 617,
	"./video_image.jpg": 618,
	"./volunteers_hero_image.png": 619,
	"./volunteers_hero_image_svg.svg": 620,
	"./way_hero_image_v3.png": 621,
	"./whats_new_icon.svg": 622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;